import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Home from './components/Home';
import UploadPODs from './components/UploadPODs';
import DownloadPODs from './components/DownloadPODs';
import CodeValidation from './components/CodeValidation';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
`;

const MainContent = styled(motion.main)`
  padding-top: 80px;
  min-height: calc(100vh - 80px);
`;

function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [isValidated, setIsValidated] = useState(false);

  const handleValidationSuccess = () => {
    setIsValidated(true);
  };

  const handleLogout = () => {
    setIsValidated(false);
  };

  // Check if user is already validated on component mount
  useEffect(() => {
    const savedCode = localStorage.getItem('podValidationCode');
    const VALIDATION_CODE = process.env.REACT_APP_VALIDATION_CODE || 'POD2024';
    
    if (savedCode && savedCode.toUpperCase() === VALIDATION_CODE.toUpperCase()) {
      setIsValidated(true);
    }
  }, []);

  // If not validated, show only the validation component
  if (!isValidated) {
    return <CodeValidation onValidationSuccess={handleValidationSuccess} />;
  }

  return (
    <Router>
      <AppContainer>
        <Header activeTab={activeTab} setActiveTab={setActiveTab} onLogout={handleLogout} />
        <MainContent
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/upload" element={<UploadPODs />} />
            <Route path="/download" element={<DownloadPODs />} />
          </Routes>
        </MainContent>
      </AppContainer>
    </Router>
  );
}

export default App; 